export default __webpack_public_path__ + "static/Cover-a4756d1aaa008aa68bb99411ae20a07e.jpg";